const designSlide = (() => {

  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {


    // const swiper = new Swiper(".swiper", {
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true,
    //   },
    //   loop: true,
    //   loopAdditionalSlides: 1,
    //   speed: 3000,
    //   autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    //     waitForTransition: false,
    //   },
    //   followFinger: false,
    //   allowTouchMove: false,
    // })

    const element = document.getElementById("image-compare");
  
    const viewer = new ImageCompare(element).mount();






  }

})();
export default designSlide;